





















// @ is an alias to /src
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import {debounce} from "lodash";

const EMPTY_STRING = '';

@Component({
  name: 'ShipmentInput',
})
export default class ShipmentInput extends Vue {
  @Prop({ default: "default label" })
  private label!: string;

  @Prop({ default: EMPTY_STRING })
  private value!: string;

  @Prop({ default: EMPTY_STRING })
  private placeholder!: string;

  @Prop({ default: false })
  private disabled!: boolean;

  private localValue: string = EMPTY_STRING;
  private type: string = 'text';

  private handleInputDebounced: () => void = () => true;

  @Watch('value')
  private updateValue() {
    this.localValue = this.value;
  }

  private mounted() {
    this.handleInputDebounced = debounce(
        () => this.handleInput(),
        200,
        {leading: false, trailing: true});
    this.updateValue();
  }

  private handleInput() {
    this.$emit('input', this.localValue);
  }

  private onBlur(e: any) {
    this.$emit('blur', e);
  }

}
